import styled, { css } from 'styled-components';
import { IconContainer } from '@anwb/icon';
import { pxToRem } from '@anwb/style-utilities';
import Typography from '@anwb/typography';
import Panel from '../../../Panel';
import { PanelHeaderContainer } from '../../../components/PanelHeader';
/**
 * StyledContainer
 */
export const styledContainerStyles = ({ theme }) => css `
	${PanelHeaderContainer} {
		margin-bottom: ${pxToRem(theme.spacing['300'])};
	}
	padding-bottom: ${pxToRem(theme.spacing['300'])};
`;
export const StyledContainer = styled(Panel).attrs({
    variant: 'featured',
    tagName: 'article',
}) `
	${styledContainerStyles}
`;
/**
 * StyledDivider
 */
export const styledDividerStyles = ({ theme }) => css `
	width: 100%;
	height: ${pxToRem(theme.borderWidth['2'])};
	margin: ${pxToRem(theme.spacing['100'])} 0;
	background-color: ${theme.colors.light.divider};
`;
export const StyledDivider = styled.div `
	${styledDividerStyles}
`;
/**
 * StyledRow
 */
export const styledRowStyles = ({ theme, $columns = false, }) => css `
	padding: ${pxToRem(theme.spacing['100'])} ${pxToRem(theme.spacing['200'])};
	display: flex;
	flex-direction: column;
	align-items: flex-start;

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		padding: ${pxToRem(theme.spacing['100'])} ${pxToRem(theme.spacing['300'])};
	}

	${$columns &&
    css `
		flex-direction: row;
		align-items: flex-start;
	`}

	${IconContainer} {
		color: ${theme.colors.base.bgFooter};
		margin-right: ${pxToRem(theme.spacing['200'])};
	}
`;
export const StyledRow = styled.div `
	${styledRowStyles}
`;
export const styledGroupStyles = () => css `
	display: flex;
	flex-direction: column;
`;
export const StyledGroup = styled.div `
	${styledGroupStyles}
`;
/**
 * StyledSubTitle
 */
export const styledSubTitleStyles = ({ theme }) => css `
	font-size: ${pxToRem(theme.fontSize['400'])};
	margin: 0 0 ${pxToRem(theme.spacing['100'])} 0;
`;
export const StyledSubtitle = styled(Typography).attrs({
    variant: 'component-subtitle',
}) `
	${styledSubTitleStyles}
`;
/**
 * StyledLabelTitle
 */
export const styledLabelTitleStyles = ({ theme }) => css `
	margin: 0;
	font-size: ${pxToRem(theme.fontSize['400'])};
`;
export const StyledLabelTitle = styled(Typography).attrs({
    variant: 'label-title',
}) `
	${styledLabelTitleStyles}
`;
/**
 * StyledActionLink
 */
export const styledActionLinkStyles = ({ theme }) => css `
	color: ${theme.colors.base.textLink};
	text-decoration: none;
	&:hover {
		color: ${theme.colors.highlight.textHover};
	}

	&:focus,
	&:active {
		color: ${theme.colors.action.textActive};
	}
`;
export const StyledActionLink = styled(Typography).attrs({
    variant: 'content-subtitle',
    tagName: 'a',
}) `
	${styledActionLinkStyles}
`;
/**
 * StyledSupportText
 */
export const styledSupportTextStyles = ({ theme }) => css `
	// Core UI override
	margin: 0;
	color: ${theme.colors.informative.textSupport};
`;
export const StyledSupportText = styled(Typography).attrs({
    variant: 'support-text',
    tagName: 'small',
}) `
	${styledSupportTextStyles}
`;
/**
 * StyledText
 */
export const styledTextStyles = ({ theme }) => css `
	color: ${theme.colors.base.textBody};
	margin: 0 0 ${pxToRem(theme.spacing['300'])} 0;

	&:last-child {
		margin-bottom: 0;
	}
`;
export const StyledText = styled(Typography).attrs({
    variant: 'body-text',
    tagName: 'p',
}) `
	${styledTextStyles}
`;
/**
 * StyledTable
 */
export const styledTableStyles = ({ theme }) => css `
	margin: 0 0 ${pxToRem(theme.spacing['300'])} 0;
	width: 100%;
	color: ${theme.colors.base.textBody};

	&:last-child {
		margin-bottom: 0;
	}
`;
export const StyledTable = styled.table `
	${styledTableStyles}
`;
//# sourceMappingURL=panel-contact.styled.js.map